import {
  DELETE_EDI_RECORD_REQUEST,
  DELETE_EDI_RECORD_SUCCESS,
  DELETE_EDI_RECORD_FAILURE,
  CLEAR_RECORD_DELETED_POPUP,
} from "../actionTypes";

import edi from "../service/cbp";

const deleteEdiRecord = () => {
  return {
    type: DELETE_EDI_RECORD_REQUEST,
  };
};

const deleteEdiRecordSuccess = (recordDeleted) => {
  return {
    type: DELETE_EDI_RECORD_SUCCESS,
    payload: recordDeleted,
  };
};
export const clearRecordDeletedPopup = () => {
  return {
    type: CLEAR_RECORD_DELETED_POPUP,
  };
};
const deleteEdiRecordFailure = (error) => {
  return {
    type: DELETE_EDI_RECORD_FAILURE,
    payload: error,
  };
};

export const deleteRecord = (requestid, country, usFormType) => {
  return async (dispatch) => {
    dispatch(deleteEdiRecord());

    let response = await edi.deleteEdiRequest(requestid, country, usFormType);
    const recordDeletedMessage = response.data.eventMessage;
    dispatch(deleteEdiRecordSuccess(recordDeletedMessage));
  };
};
